import type { TypographyConfig } from '../../types/widget-types'
import { parseDataAttributes } from '../../utilities/utilities'

export type StockStatusConfigStyles = {
  stockStatusTypography?: TypographyConfig
}

export type StockStatusAttributes = {
  configStyles?: StockStatusConfigStyles
}

export default function propsFn(dataAttributes: NamedNodeMap): StockStatusAttributes {
  const base = parseDataAttributes(dataAttributes)
  return {
    configStyles: base.configStyles as StockStatusConfigStyles | undefined,
  }
}
